import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Popup } from 'semantic-ui-react';
import { Select, Button } from 'antd';
import styles from './ProfileSettings.module.scss';
import { usePrevious } from '../../../../util/hooks';

import { editMe } from 'legacy/actions/userActions';
import { showModal } from 'legacy/actions/modalActions';

const { Option } = Select;

const defaultOptions = ['everyone', 'friends', 'none'];

const getDisplayNameMap = (t) => ({
  everyone: t('users:settings.privacy.levels.everyone'),
  friends: t('users:settings.privacy.levels.friends'),
  none: t('users:settings.privacy.levels.none')
});

const getPrivacyInputConfig = (t) => [
  {
    title: t('users:settings.privacy.options.contactInfo'),
    key: 'contact',
    options: defaultOptions,
    tag: 'contact-info'
  },
  {
    title: t('users:settings.privacy.options.profileDetails'),
    key: 'profile',
    options: defaultOptions,
    tag: 'profile-details',
    tooltip: t('users:settings.privacy.tooltip')
  },
  {
    title: t('users:settings.privacy.options.events'),
    key: 'events',
    options: defaultOptions,
    tag: 'events'
  }
];

const getMapDeprecated = (privacyInputConfig) => ({
  open: privacyInputConfig.reduce(
    (acc, { key }) => ({ ...acc, [key]: 'everyone' }),
    {}
  ),
  closed: privacyInputConfig.reduce(
    (acc, { key }) => ({ ...acc, [key]: 'friends' }),
    {}
  )
});

const Privacy = ({ user, editMe, loading, showModal, error }) => {
  const { t } = useTranslation(['users']);
  const { privacy } = user;
  
  const privacyInputConfig = getPrivacyInputConfig(t);
  const displayNameMap = getDisplayNameMap(t);
  const mapDeprecated = getMapDeprecated(privacyInputConfig);

  const [fields, setFields] = useState(
    typeof privacy === 'string' ? mapDeprecated[privacy] : privacy
  );

  const handleFieldChange = (key, value) => {
    setFields((fields) => ({
      ...fields,
      [key]: value
    }));
  };

  const prevLoading = usePrevious(loading);
  useEffect(() => {
    if (!loading && prevLoading) {
      if (isEmpty(error)) {
        showModal('ALERT', {
          message: t('users:settings.privacy.success'),
          type: 'success'
        });
      } else {
        showModal('ALERT', { message: error.message });
      }
    }
  }, [loading, error]);

  const inputs = privacyInputConfig.map(
    ({ title, key, options, tag, tooltip }) => (
      <div key={key}>
        <span>
          {title}
          {tooltip && (
            <Popup
              size="tiny"
              position="right center"
              trigger={<i className="fa fa-info-circle" />}
              content={tooltip}
            />
          )}
        </span>

        <Select
          defaultValue={fields[key] || 'friends'}
          data-cy={tag}
          onChange={(val) => handleFieldChange(key, val)}
        >
          {options.map((option) => (
            <Option
              key={option}
              value={option}
              data-cy={displayNameMap[option]}
            >
              {displayNameMap[option]}
            </Option>
          ))}
        </Select>
      </div>
    )
  );

  return (
    <>
      <h1>{t('users:settings.privacy.title')}</h1>
      <div className={styles.responsiveCol}>{inputs}</div>
      <Button
        className={styles.submit}
        onClick={() => editMe({ privacy: fields })}
        loading={loading}
      >
        {t('users:settings.privacy.save')}
      </Button>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading.EDIT_ME,
  error: state.user.errors.EDIT_ME
});

const actions = { editMe, showModal };

export default connect(mapStateToProps, actions)(Privacy);
